export default {
   /* eslint-disable key-spacing */
   '01': 'Badan Hukum',
   '02': 'Bukan Badan Hukum',
   /* eslint-enable key-spacing */
}
